import { downloadFileById, getFileDetails } from "../services/api";

const triggerBlobDownload = (blobData, fileName) => {
  const url = URL.createObjectURL(blobData);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName || "file.pdf");
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

export const downloadAttachment = ({
  file,
  id,
  type = "alert",
  alertID,
  headers,
  dispatch,
  showToast,
}) => {
  const key = file?.key;
  const fileName = file?.name;

  if (!key) return;

  const downloadFile = () => {
    getFileDetails(key, headers, dispatch, (response) => {
      if (response.result === "SUCCESS") {
        try {
          triggerBlobDownload(response.data, fileName);
        } catch (error) {
          showToast(error.severity, error?.errorMsg || error?.summary);
        }
      } else {
        const error = response?.error;
        showToast(error.severity, error?.errorMsg || error?.summary);
      }
    });
  };

  const requestBody = {
    key,
    name: fileName,
    size: file?.size ? String(file.size) : "",
    type: file?.type || "application/octet-stream",
  };

  downloadFileById(
    { id, type, ...(alertID ? { alertID } : {})},
    requestBody,
    headers,
    dispatch,
    (response) => {
      if (response.result !== "SUCCESS") {
        const error = response?.error;
        showToast(error.severity, error?.errorMsg || error?.summary);
      }
      downloadFile();
    }
  );
};

